(function () {
  function initSidebar(section) {
    const navLinks = section.querySelectorAll(
      '.f-sidebar__nav-link, .f-sidebar__mobile-nav-link'
    );
    const groups = section.querySelectorAll('.f-sidebar__group');

    if (!navLinks.length || !groups.length) return;

    function activateTab(targetId) {
      navLinks.forEach((l) => l.classList.remove('is-selected'));
      section
        .querySelectorAll(`[data-sidebar-target="${targetId}"]`)
        .forEach((el) => el.classList.add('is-selected'));

      groups.forEach((group) => {
        if (group.id === targetId) {
          group.classList.remove('is-hidden');
        } else {
          group.classList.add('is-hidden');
        }
      });

      const mobileBtn = section.querySelector(
        `.f-sidebar__mobile-nav-link[data-sidebar-target="${targetId}"]`
      );
      if (mobileBtn) {
        mobileBtn.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }

    function openAccordion(details) {
      details.setAttribute('open', '');
      requestAnimationFrame(() => {
        details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Build index map: #tab-1, #tab-2, etc. → group targetId
    const hashMap = {};
    navLinks.forEach((btn, i) => {
      if (!btn.classList.contains('f-sidebar__nav-link')) return;
      hashMap[`tab-${i + 1}`] = btn.dataset.sidebarTarget;
    });

    // Reverse map: targetId → hash
    const reverseHashMap = {};
    Object.entries(hashMap).forEach(([hash, targetId]) => {
      reverseHashMap[targetId] = hash;
    });

    // Also register each accordion's own id in the hash map
    // so #Widget--abc123 directly targets that accordion
    section.querySelectorAll('.f-sidebar__group details[id]').forEach((details) => {
      hashMap[details.id] = details.id;
    });

    function handleHash(rawHash) {
      if (!rawHash) return;
      const hash = rawHash.replace('#', '');

      // Case 1: matches a tab key (e.g. tab-1)
      if (hashMap[hash] && hash.startsWith('tab-')) {
        activateTab(hashMap[hash]);
        return;
      }

      // Case 2: matches a group id directly (Widget--xxx on a header group)
      const groupTarget = section.querySelector(`.f-sidebar__group#${CSS.escape(hash)}`);
      if (groupTarget) {
        activateTab(hash);
        return;
      }

      // Case 3: matches an accordion details id (Widget--xxx on an accordion)
      const accordionTarget = section.querySelector(
        `.f-sidebar__group details#${CSS.escape(hash)}`
      );
      if (accordionTarget) {
        const parentGroup = accordionTarget.closest('.f-sidebar__group');
        if (parentGroup) {
          activateTab(parentGroup.id);
        }
        openAccordion(accordionTarget);
      }
    }

    // Nav link clicks — update hash to tab-N
    navLinks.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetId = btn.dataset.sidebarTarget;
        activateTab(targetId);

        const hash = reverseHashMap[targetId];
        if (hash) {
          history.replaceState(null, '', `#${hash}`);
        }
      });
    });

    // Accordion clicks — update hash to the accordion's own id
    section.querySelectorAll('.f-sidebar__group details[id]').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', () => {
        // Only update hash when opening, not closing
        if (!details.hasAttribute('open')) {
          history.replaceState(null, '', `#${details.id}`);
        } else {
          // Closing — revert to the group's tab hash
          const parentGroup = details.closest('.f-sidebar__group');
          if (parentGroup) {
            const tabHash = reverseHashMap[parentGroup.id];
            if (tabHash) history.replaceState(null, '', `#${tabHash}`);
          }
        }
      });
    });

    // Handle hash on load and on back/forward navigation
    handleHash(window.location.hash);
    window.addEventListener('hashchange', () => handleHash(window.location.hash));
  }

  document
    .querySelectorAll('[data-section-type="sidebar"]')
    .forEach(initSidebar);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-section-type="sidebar"]');
    if (section) initSidebar(section);
  });
})();